import { c as _c } from "react/compiler-runtime";
import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { AppSidebarTrigger } from '@/components/navigation/AppSidebarTrigger';
import { locateInNavigation, type NavigationStep } from '@/components/navigation/app-navigation';
import { useTranslation } from '@/hooks/use-translation';
import { Breadcrumb, type Crumb } from './Breadcrumb';
export interface PageHeaderProps {
  /** What sits on the right of the bar: an identity, an indicator, an action. */
  right?: React.ReactNode;
  /** The navigation model, built once by the layout. */
  steps: NavigationStep[];
}

/**
 * The thin bar above every page: where you are on the left, what you can do
 * about it on the right. The page title lives in the page itself, not here.
 */
export const PageHeader = t0 => {
  const $ = _c(27);
  const {
    right,
    steps
  } = t0;
  const {
    pathname
  } = useLocation();
  const {
    t
  } = useTranslation();
  let t1;
  bb0: {
    if (pathname === "/help") {
      let t2;
      if ($[0] !== t) {
        t2 = t("Help", {
          ns: "navigation"
        });
        $[0] = t;
        $[1] = t2;
      } else {
        t2 = $[1];
      }
      let t3;
      if ($[2] !== t2) {
        t3 = [{
          text: t2,
          tone: "leaf"
        }];
        $[2] = t2;
        $[3] = t3;
      } else {
        t3 = $[3];
      }
      t1 = t3;
      break bb0;
    }
    let t2;
    if ($[4] !== pathname || $[5] !== steps) {
      t2 = locateInNavigation(steps, pathname);
      $[4] = pathname;
      $[5] = steps;
      $[6] = t2;
    } else {
      t2 = $[6];
    }
    const {
      link,
      step
    } = t2;
    if (!step) {
      let t3;
      if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = [];
        $[7] = t3;
      } else {
        t3 = $[7];
      }
      t1 = t3;
      break bb0;
    }
    let t3;
    if ($[8] !== step.number) {
      t3 = step.number ? [{
        text: step.number,
        tone: "step" as const
      }] : [];
      $[8] = step.number;
      $[9] = t3;
    } else {
      t3 = $[9];
    }
    const t4 = link ? "mid" : "leaf";
    let t5;
    if ($[10] !== step.label || $[11] !== t4) {
      t5 = {
        text: step.label,
        tone: t4
      };
      $[10] = step.label;
      $[11] = t4;
      $[12] = t5;
    } else {
      t5 = $[12];
    }
    let t6;
    if ($[13] !== link) {
      t6 = link ? [{
        text: link.label,
        tone: "leaf" as const
      }] : [];
      $[13] = link;
      $[14] = t6;
    } else {
      t6 = $[14];
    }
    let t7;
    if ($[15] !== t3 || $[16] !== t5 || $[17] !== t6) {
      t7 = [...t3, t5, ...t6];
      $[15] = t3;
      $[16] = t5;
      $[17] = t6;
      $[18] = t7;
    } else {
      t7 = $[18];
    }
    t1 = t7;
  }
  const crumbs = t1;
  let t2;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <AppSidebarTrigger className="-ml-1" />;
    $[19] = t2;
  } else {
    t2 = $[19];
  }
  let t3;
  if ($[20] !== crumbs) {
    t3 = <div className="flex items-center gap-2">{t2}<Breadcrumb crumbs={crumbs} /></div>;
    $[20] = crumbs;
    $[21] = t3;
  } else {
    t3 = $[21];
  }
  let t4;
  if ($[22] !== right) {
    t4 = <div className="flex flex-wrap items-center gap-3.5">{right}</div>;
    $[22] = right;
    $[23] = t4;
  } else {
    t4 = $[23];
  }
  let t5;
  if ($[24] !== t3 || $[25] !== t4) {
    t5 = <div data-slot="page-header" className="flex flex-wrap items-center justify-between gap-3 border-b border-border px-10 py-3.5 max-md:px-4 print:hidden">{t3}{t4}</div>;
    $[24] = t3;
    $[25] = t4;
    $[26] = t5;
  } else {
    t5 = $[26];
  }
  return t5;
};